/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { API_TIMEOUT_ERROR } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchProviderListDetails = (data) => ({
  type: actionTypes.SEARCH_PROVIDER_DETAILS,
  providerList: data,
});

export const dispatchProviderTypeDetails = (data) => ({
  type: actionTypes.GET_PROVIDERIDTYPE_DATA,
  providerIdType: data,
});

export const dispatchProvideDetails = (searchData) => ({
  type: actionTypes.GET_PROVIDER_DETAILS,
  providerDetails: searchData,
});

export const dispatchProvideDetailsData = (data) => ({
  type: actionTypes.GET_PROVIDER_DETAILS_DATA,
  providerDetailsData: data,
});

export const dispatchContactDetails = (data) => ({
  type: actionTypes.GET_CONTACT_DETAILS,
  contactDetails: data,
});

export const dispatchExistingContactDetails = (data) => ({
  type: actionTypes.GET_EXISTING_CONTACT_DETAILS,
  existingContactDetails: data,
});
export const dispatchContactDescriptionDetails = (data) => ({
  type: actionTypes.GET_CONTACT_DESCRIPTION_DETAILS,
  contactDescription: data,
});

export const dispatchProviderTabData = (payload) => ({
  type: actionTypes.SET_PROVIDER_TAB_DATA,
  payload,
});

export const searchProviderReqAction = (data) => {
  return {
    type: 'SEARCH_PROVIDER_REQUEST',
    payload: data,
  };
};

export const getProviderIdTypeDetails = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_CHECK_PAYEE}?codeDomainKey=PROVIDER_ID_TYPE_CD`)
    .then((response) => {
      dispatch(dispatchProviderTypeDetails(response.data));
    })
    .catch(() => {
      dispatch(dispatchProviderTypeDetails({ error: 'API failed' }));
    });
};
export const getProviderDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER_DETAILS, values)
    .then((response) => {
      dispatch(dispatchProvideDetailsData(response.data));
    })
    .catch(() => {
      dispatch(dispatchProvideDetailsData({ error: 'API failed' }));
    });
};

export const getContactDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_DETAILS, values)
    .then((response) => {
      dispatch(dispatchContactDetails(response.data));
    })
    .catch(() => {
      dispatch(dispatchContactDetails({ error: 'API failed' }));
    });
};
export const getExistingContactDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_CONTACT_DETAILS, values)
    .then((response) => {
      dispatch(dispatchExistingContactDetails(response.data));
    })
    .catch(() => {
      dispatch(dispatchExistingContactDetails({ error: 'API failed' }));
    });
};
export const getContactDescriptionDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_DESCRIPTION_DETAILS, values)
    .then((response) => {
      dispatch(dispatchContactDescriptionDetails(response.data));
    })
    .catch(() => {
      dispatch(dispatchContactDescriptionDetails({ error: 'API failed' }));
    });
};
export const getProviderList = (values, setErrorCallback) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SEARCH_PROVIDER_DETAILS, values)
    .then((response) => {
      dispatch(dispatchProviderListDetails(response.data));
    })
    .catch((error) => {
    
      if (!error.response || error.response.status === 500 || error.code === 'ECONNABORTED') {
        if (setErrorCallback) setErrorCallback(API_TIMEOUT_ERROR);
      } else if (error.response && error.response.status === 0) {
   
        if (setErrorCallback) setErrorCallback(API_TIMEOUT_ERROR);
      } else {
        if (setErrorCallback) setErrorCallback(API_TIMEOUT_ERROR);
      }
     
      dispatch(dispatchProviderListDetails({ data: [] }));
    });
};
export const clearReduxProviderSearchScreen = () => (dispatch) => {
  dispatch(searchProviderReqAction({}));
  dispatch(dispatchProviderListDetails([]));
};
export const clearReduxProviderDetailScreen = () => (dispatch) => {
  dispatch(dispatchExistingContactDetails([]));
  dispatch(dispatchContactDetails({}));
  dispatch(dispatchProvideDetailsData([]));
  dispatch(dispatchContactDescriptionDetails([]));
  dispatch(dispatchProvideDetails([]));
  dispatch(dispatchProviderTabData({}));
};
